import { render, staticRenderFns } from "./TopicsListEdit.vue?vue&type=template&id=8e0d04aa&"
import script from "./TopicsListEdit.vue?vue&type=script&lang=js&"
export * from "./TopicsListEdit.vue?vue&type=script&lang=js&"
import style0 from "./TopicsListEdit.vue?vue&type=style&index=0&id=8e0d04aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports